module.exports = __webpack_public_path__ + "static/media/Await.111b678b.png";